export default "__VITE_ASSET__Cfk0h22c__"